import { render, staticRenderFns } from "./riskStatusTable.vue?vue&type=template&id=570a8aac&scoped=true&"
import script from "./riskStatusTable.vue?vue&type=script&lang=js&"
export * from "./riskStatusTable.vue?vue&type=script&lang=js&"
import style0 from "./riskStatusTable.vue?vue&type=style&index=0&id=570a8aac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570a8aac",
  null
  
)

export default component.exports